import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=42e2857b&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=42e2857b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2857b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e2857b')) {
      api.createRecord('42e2857b', component.options)
    } else {
      api.reload('42e2857b', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=42e2857b&scoped=true&", function () {
      api.rerender('42e2857b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Common/Header.vue"
export default component.exports